import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {loadConfig} from './support/Config';

/**
 * Единственная точка входа приложения (CTHS-64).
 *
 * <p>Раньше рядом жили два entry-модуля: `index.js` с барьером конфигурации и `index.tsx`
 * без него. CRA резолвит `.js` раньше `.tsx`, поэтому работал первый, а второй выглядел
 * рабочим и не был им. Удаление «лишнего» файла тихо переключило бы приложение на конфиг
 * по умолчанию — чужой Keycloak и чужой `apiBaseUrl`, — и отказ всплыл бы только в проде.</p>
 *
 * <p>Поэтому здесь один барьер: рендер начинается только после того, как `loadConfig()`
 * разрешился. Разрешился — не значит «успешно»: сам `loadConfig` при сбое падает на
 * значения по умолчанию и не бросает. Ветка `catch` остаётся страховкой на непредвиденное
 * (например, отказ самого `fetch` в окружении без сети): приложение всё равно должно
 * подняться, иначе человек видит белый экран вместо экрана входа.</p>
 */
const renderApp = (): void => {
    const container = document.getElementById('root');
    if (!container) {
        return;
    }
    const root = ReactDOM.createRoot(container);
    root.render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    );

    // Метрики производительности: передайте функцию (например, reportWebVitals(console.log)),
    // чтобы увидеть значения, или отправляйте их в аналитику. https://bit.ly/CRA-vitals
    reportWebVitals();
};

loadConfig()
    .catch(error => {
        console.error('Failed to load config:', error);
    })
    .finally(renderApp);
